module.exports = "<div class=\"saveCard\">\r\n    <div ng-if=\"$ctrl.error\" class=\"u-error\">{{ $ctrl.error }}</div>\r\n    <div>\r\n        Save {{$ctrl.paymentType}} for future purchases\r\n        <button class=\"button button--primary\" ng-click=\"$ctrl.saveCard()\" ng-if=\"!$ctrl.cardSaved\">\r\n            Save\r\n        </button>\r\n        <button class=\"button button--primary\" ng-if=\"$ctrl.cardSaved\" disabled>\r\n            Saved <i class=\"iconww-Tick\"></i>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/order/savedcard/save-card.component.html
// module id = 752
// module chunks = 0